"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingsValueSelector = void 0;

var settingsValueSelector = function settingsValueSelector(state, settingsKey) {
  var settings = state.settings;
  return settings[settingsKey] ? Boolean(settings[settingsKey].value) : false;
};

exports.settingsValueSelector = settingsValueSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/SettingsSelectors.js
// module id = 789
// module chunks = 5 6